import ListPage, { useList } from '@/components/BaseList';
import { usePermission } from '@/common/hooks/index';
import { httpPageOdsGdMedServiceBase } from '@/services/datamanagement';
import React from 'react';
import SearchForm from './components/SearchForm';

/**
 * 医疗服务收费项目医保目录
 * @returns
 */
const catalogueMedicalItem: React.FC = () => {
  const { permission } = usePermission();

  const list = useList();
  const fetchAPi = (params: any) => {
    const req: any = {
      // ...params,
      limit: params.pageSize,
      pageNo: params.current,
      cond: {
        medicareCode: params.medicareCode,
        name: params.name,
        feeCategory: params.feeCategory,
      },
      // orders: [
      //   {
      //     direction: params.direction === 'ascend' ? 'ASC' : 'DESC',
      //     property: params.property || 'createTime',
      //   },
      // ],
    };

    return httpPageOdsGdMedServiceBase(req).then((res) => {
      return {
        listData: res.data,
        pagination: {
          current: res.pageIndex,
          pageSize: res.pageSize,
          total: res.totalCount,
        },
      };
    });
  };

  const changetable = (pagination: any, filters: any, sorter: any) => {
    const property: string = sorter.columnKey;
    list.current.fetchListData({ direction: sorter.order, property });
  };

  const columns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 100,
      children: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          minWidth: 100,
        },
      ],
    },
    {
      title: '医保项目编号',
      dataIndex: 'medicareCode',
      key: 'medicareCode',
      minWidth: 300,
      children: [
        {
          title: 'medicareCode',
          dataIndex: 'medicareCode',
          key: 'medicareCode',
          minWidth: 300,
        },
      ],
    },
    {
      title: '医保项目名称',
      dataIndex: 'name',
      key: 'name',
      children: [
        {
          title: 'name',
          dataIndex: 'name',
          key: 'name',
        },
      ],
    },
    {
      title: '目录类别',
      dataIndex: 'itemCategory',
      key: 'itemCategory',
      children: [
        {
          title: 'itemCategory',
          dataIndex: 'itemCategory',
          key: 'itemCategory',
        },
      ],
    },
    {
      title: '统计类别',
      dataIndex: 'feeCategory',
      key: 'feeCategory',
      children: [
        {
          title: 'feeCategory',
          dataIndex: 'feeCategory',
          key: 'feeCategory',
        },
      ],
    },
  ];

  return (
    <div className="content-page">
      <ListPage
        list={list}
        fetchApi={fetchAPi}
        columns={columns}
        SearchForm={permission.sysSearchBtn && SearchForm}
        BodyProps={{
          onChange: (pagination: any, filters: any, sorter: any) => {
            changetable(pagination, filters, sorter);
          },
        }}
      />
    </div>
  );
};

export default catalogueMedicalItem;
